const template = (target, x) => {
    return `<button class="${target}__bullet" data-glide-dir="=${x}"></button>`;
};

export const createBullet = (target, x) => {
    let element = document.createElement("template");
    element.innerHTML = template(target, x);
    return element.content.firstChild;
};

export default template;